import React, { FC, ReactElement } from 'react'
import {
  Box,
  Toolbar,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import ListItem from '@mui/material/ListItem'
import { Dashboard, ViewList } from '@mui/icons-material'
import { drawerOpenAtom } from '../state'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { Drawer } from '../styles'
import { resources } from '../resources'
import { PlainLink } from './RouteLink'

function Item({
  title,
  compKey,
  Icon = ViewList,
}: {
  title: string
  compKey: string
  Icon?: FC
}) {
  const text = {
    color: 'rgba(0, 0, 0, 0.54)',
    fontWeight: 400,
    fontSize: '1rem',
  }
  return (
    <ListItem dense={true} component={PlainLink} to={`/${compKey}`}>
      <ListItemButton>
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{ style: text }}
          primary={title}
        />
      </ListItemButton>
    </ListItem>
  )
}

export function AppDrawer() {
  const open = useAtomValue(drawerOpenAtom)
  return (
    <Drawer variant="permanent" open={open} style={{ width: 300 }}>
      <Toolbar />
      <Box sx={{ overflow: 'auto' }}>
        <List>
          <Item compKey={''} title={'Dashboard'} Icon={Dashboard} />
          {resources
            .filter(({ unlisted }) => !unlisted)
            .reduce<ReactElement[]>((acc, { key, title, List }) => {
              if (List) {
                acc.push(<Item title={title} key={key} compKey={key} />)
              }
              return acc
            }, [])}
        </List>
      </Box>
    </Drawer>
  )
}
